module.exports = __webpack_public_path__ + "static/media/en_badge_web_generic.db9b21a1.png";